<template>
  <div v-if="params.value !== null && params.value !== undefined">
    <span class="ml-3 font-11 w-100">
      <vs-dropdown vs-trigger-click class="w-100">
        <b-button :variant="colorbtn" class="font-11" href="#" v-if="!select">
          {{ params.value.value }}
          <vs-icon class="" icon="expand_more"> </vs-icon
        ></b-button>

        <!-- <a class="a-icon font-11" href="#" v-if="!select" >
          {{ params.value.value }}
          <vs-icon class="" icon="expand_more"> </vs-icon>
        </a> -->
        <b-button :variant="colorbtn" class="font-11" href="#" v-else>
          {{ select }}
          <vs-icon class="" icon="expand_more"> </vs-icon>
        </b-button>
        <vs-dropdown-menu>
          <vs-dropdown-item
            v-for="(item, index) in params.value.choice"
            :key="index"
            :value="item.name"
            v-model="select"
            class="font-11 px-5"
            @click="clickAction(item)"
          >
            {{ item.name }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </span>
  </div>
  <div v-else>
    <div class="justify-content-center d-flex">
      -
      <!-- <b-icon class="mt-1 cursor-pointer" disabled  icon="file-person" font-scale="3" style="color:#7d7d7d" ></b-icon> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios";
import baseurl from "../../../../util/backend";
export default {
  data() {
    return {
      choice: null,
      select: null,
    };
  },
  mounted() {
    // console.log("params", this.params.data);
    this.choice = this.params.data.dropdown_choice;
  },
  methods: {
    async clickAction(item) {
      console.log("item dropdown", item.postTo);
      // axios.post(`${item.url}`,select)
      try {
        await this.postDropdown(item.postTo, item.value);
        // this.select = item.name
      } catch (er) {
        alert("เกิดข้อผิดพลาดกรุณาลองใหม่");
      }
      console.log("this.selcet", this.select, item);
    },
    async postDropdown(url, val) {
      // alert(baseurl());
      console.log("url", url, val);
      await axios
        .post(`${baseurl()}${url}`, { value: val })
        .then((res) => {
          console.log(res.data);
          if (res.data.status === "success") {
            const result = this.params.value.choice.filter(
              (item) => item.value == val
            );
            this.select = result[0].name;
            //return res.data.data
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
  },
  computed: {
    ...mapGetters({
      nowPage: "getNowPage",
    }),
    colorbtn() {
      // console.log("value", this.params.value.value);
      // console.log("choice", this.params.value.choice);
      if (this.select) {
        let result = this.params.value.choice.filter(
          (value) => value.name == this.select
        );
        return result[0].color
          ? `outline-${result[0].color}`
          : "outline-secondary";
      } else {
        let result = this.params.value.choice.filter(
          (value) => value.name == this.params.value.value
        );
        return result[0].color
          ? `outline-${result[0].color}`
          : "outline-secondary";
      }
    },
  },
};
</script>
<style>
.font-11 {
  font-size: 11px;
}
.successS {
  color: black;
  background: #dbffe5 !important;
}
.dangerS {
  color: black;
  background: #ffd7d7 !important;
}
.pendingS {
  color: black;
  background: #fff4d9 !important;
}
.successS {
  color: #0ec742 !important;
}
.dangerS {
  color: #ed1616 !important;
}
.pendingS {
  color: #e9a800 !important;
}
</style>
